/* eslint-disable no-console */
import axios from "axios";
import { getToken } from "store/auth";

const url_path = "https://api.number.com.br";
//const url_path = "https://api2.number.com.br";
//const url_path = "https://localhost:44333";
//const url_path = "https://172.16.160.102:44333";

export default () => {
  const token = getToken();

  return axios.create({
    baseURL: `${url_path}/api/`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};